import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react'
import clsx from 'clsx'
import Link from 'next/link'
import { Fragment } from 'react'
import { Breadcrumb } from '@/src/components/flch/breadcrumbs'

export default function Breadcrumbs({
  items,
  currentAsHeading = true,
  className,
}: {
  items: Breadcrumb[]
  currentAsHeading?: boolean
  className?: string
}) {
  const links = items.filter((item) => item.href)
  const backItem = links[links.length - 1]

  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex flex-wrap items-center gap-1 text-sm text-gray-600">
        {items.map((item, index) => (
          <Fragment key={item.name}>
            {index > 0 && (
              <li
                aria-hidden="true"
                className="hidden items-center text-gray-500 md:flex"
              >
                <CaretRightIcon size={16} weight="bold" />
              </li>
            )}
            <li className={clsx(item !== backItem && 'sr-only md:not-sr-only')}>
              {item.href ? (
                <Link
                  href={item.href}
                  className={clsx(
                    'flex items-center gap-1 md:underline',
                    item === backItem &&
                      'font-bold text-gray-800 md:font-normal md:text-gray-600'
                  )}
                >
                  {item === backItem && (
                    <CaretLeftIcon
                      size={20}
                      weight="bold"
                      className="md:hidden"
                    />
                  )}
                  {item.name}
                </Link>
              ) : currentAsHeading ? (
                <h1 aria-current="page">{item.name}</h1>
              ) : (
                <span aria-current="page">{item.name}</span>
              )}
            </li>
          </Fragment>
        ))}
      </ol>
    </nav>
  )
}
